import regulationTypes from '../regulationTypes';

export default [
    {
        countryCode: ['CH'],
        regulations: [
            { name: regulationTypes.VERSION },
            { name: regulationTypes.FEATURE_BUY_VERSION },
            { name: regulationTypes.MAX_MULTIPLIER_TEXT }
        ]
    },
    {
        countryCode: ['US'],
        regulations: [
            { name: regulationTypes.DRAG },
            { name: regulationTypes.MAX_MULTIPLIER_TEXT },
            { name: regulationTypes.PAYOUT_EXAMPLE_TEXT_NO_MULTILINE }
        ]
    },
    {
        countryCode: ['SE'],
        regulations: [
            { name: regulationTypes.HELP },
            { name: regulationTypes.TURBO },
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 3 } }
        ]
    },
    {
        countryCode: ['DK'],
        regulations: [
            { name: regulationTypes.HELP },
            { name: regulationTypes.TURBO },
            { name: regulationTypes.VERSION },
            { name: regulationTypes.FEATURE_BUY_VERSION },
            { name: regulationTypes.TURBO_SPIN },
            { name: regulationTypes.SKIP_ANIMATION },
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 3 } },
            { name: regulationTypes.MIN_ROUND_DURATION_STRICT }
        ]
    },
    {
        countryCode: ['GR'],
        regulations: [
            { name: regulationTypes.HELP },
            { name: regulationTypes.TURBO },
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 2 } },
            { name: regulationTypes.MAX_MULTIPLIER_TEXT },
        ]
    },
    {
        countryCode: ['ES'],
        regulations: [
            { name: regulationTypes.HELP },
            { name: regulationTypes.TURBO },
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 3 } },
            { name: regulationTypes.WHEEL_WIN_ONLY },
            { name: regulationTypes.VERSION }
        ]
    },
    {
        countryCode: ['UK', 'GB'],
        regulations: [
            { name: regulationTypes.TURBO },
            { name: regulationTypes.TURBO_SPIN },
            { name: regulationTypes.SKIP_ANIMATION },
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 2.5 } },
            { name: regulationTypes.STOP_AUTOPLAY }
        ]
    },
    {
        countryCode: ['CA'],
        regulations: [
            { name: regulationTypes.DRAG },
            { name: regulationTypes.MAX_MULTIPLIER_TEXT },
            { name: regulationTypes.VERSION }
        ]
    },
    {
        countryCode: ['NL'],
        regulations: [
            { name: regulationTypes.TURBO_SPIN }
        ]

    },
    {
        countryCode: ['CO'],
        regulations: [
            { name: regulationTypes.TURBO },
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 3 } },
            { name: regulationTypes.MAX_MULTIPLIER_TEXT },
        ]
    },
    {
        countryCode: ['LT'],
        regulations: [
            { name: regulationTypes.TURBO },
            { name: regulationTypes.TURBO_SPIN },
            { name: regulationTypes.SKIP_ANIMATION },
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 1 } },
            { name: regulationTypes.STOP_AUTOPLAY }
        ]
    },
    {
        countryCode: ['PT'],
        regulations: [
            { name: regulationTypes.TURBO },
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 3 } },
            { name: regulationTypes.WHEEL_WIN_ONLY }
        ]
    },
    {
        countryCode: ['CZ'],
        regulations: [
            { name: regulationTypes.TURBO },
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 2 } },
            { name: regulationTypes.HELP_MAX_MULTIPLIER }
        ]
    },
    {
        countryCode: ['BS', 'PA', 'PE', 'AR', 'BR'],
        regulations: [
            { name: regulationTypes.MAX_MULTIPLIER_TEXT }
        ]
    }
];
